import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const HousingChart = ({ data, title }) => {
    const chartOptions = {
        chart: {
            type: 'column',
            style: {
                fontFamily: 'SCDream4',
            },
        },
        title: {
            text: title,
            style: {
                fontSize: '16px',
                fontWeight: '600',
                color: '#2c3e50',
                textAlign: 'center',
            },
        },
        xAxis: {
            categories: data.chartData.map((data) => `${data.ymd.substr(0, 4)}.${data.ymd.substr(4, 2)}`),
            crosshair: {
                color: '#e8e8e8',
                width: 1,
                dashStyle: 'solid',
            },
            lineColor: '#e0e0e0',
            tickColor: '#e0e0e0',
            labels: {
                style: {
                    color: '#555',
                    fontSize: '12px',
                    fontWeight: '500',
                },
            },
        },
        yAxis: [
            {
                title: {
                    text: data.seriesOptions[0].name,
                    style: {
                        color: '#34495e',
                        fontSize: '13px',
                        fontWeight: '600',
                    },
                },
                labels: {
                    formatter: function () {
                        return this.value.toLocaleString() + data.seriesOptions[0].unit;
                    },
                    style: {
                        color: '#34495e',
                        fontSize: '11px',
                    },
                },
                gridLineColor: '#f0f0f0',
                gridLineWidth: 1,
                lineColor: '#e0e0e0',
                tickColor: '#e0e0e0',
            },
            {
                title: {
                    text: data.seriesOptions[1].name,
                    style: {
                        color: '#e74c3c',
                        fontSize: '13px',
                        fontWeight: '600',
                    },
                },
                labels: {
                    formatter: function () {
                        return this.value.toLocaleString() + data.seriesOptions[1].unit;
                    },
                    style: {
                        color: '#e74c3c',
                        fontSize: '11px',
                    },
                },
                gridLineColor: 'transparent',
                lineColor: '#e0e0e0',
                tickColor: '#e0e0e0',
                opposite: true,
            },
        ],
        tooltip: {
            backgroundColor: '#ffffff',
            borderColor: '#d0d0d0',
            borderRadius: 6,
            borderWidth: 1,
            shadow: true,
            style: {
                fontSize: '12px',
            },
            shared: true,
            formatter: function () {
                const ymd = this.points[0].key;

                let tooltip = `
                    <div style="font-weight: 600; color: #2c3e50; margin-bottom: 12px; font-size: 14px;">
                        ${ymd.substr(0, 4)}년 ${ymd.substr(5, 6)}월 
                    </div>
                    <br />
                `;

                this.points.forEach((point) => {
                    if (point.series.name === '매매 평균가') {
                        const avgPoint = this.points.find(p => p.series.name === '매매 평균가').y;

                        tooltip += `
                            <div style="margin: 8px 0; padding: 4px 0; border-bottom: 1px solid #f0f0f0;">
                                <div style="color: #34495e; margin-bottom: 4px;">
                                    <span style="font-weight: 600;">매매 평균가:</span>
                                    <span style="font-weight: 600; color: #3498db; margin-left: 8px;">
                                        ${avgPoint.toLocaleString()}만원
                                    </span>
                                </div>
                            </div>
                        `;
                    } else if(point.series.name === '환산보증금 평균가') {
                        const avgPoint = this.points.find(p => p.series.name === '환산보증금 평균가');

                        tooltip += `
                            <div style="margin: 8px 0; padding: 4px 0; border-bottom: 1px solid #f0f0f0;">
                                <div style="color: #34495e; margin-bottom: 4px;">
                                    <span style="font-weight: 600;">환산보증금 평균가:</span>
                                    <span style="font-weight: 600; color: #3498db; margin-left: 8px;">
                                        ${avgPoint.y.toLocaleString()}만원
                                    </span>
                                </div>
                            </div>
                            <div style="color: #7f8c8d;">
                                <span style="font-weight: 600;">전세가율:</span>
                                <span style="font-weight: 600; color: #7f8c8d; margin-left: 8px;">
                                    ${data.chartData.find((data) => avgPoint.x.replace(".", "") === data.ymd).deposit_rate}%
                                </span>
                            </div>
                        `;
                    } else {
                        const cntPoint = this.points.find(p => p.series.name === '거래량').y;

                        tooltip += `
                            <div style="margin: 8px 0; padding: 4px 0;">
                                <div style="color: #e74c3c;">
                                    <span style="font-weight: 600;">거래량:</span>
                                    <span style="font-weight: 600; color: #e74c3c; margin-left: 8px;">
                                        ${cntPoint.toLocaleString()}호
                                    </span>
                                </div>
                            </div>
                        `;
                    }
                });

                return tooltip;
            },
        },
        legend: {
            enabled: true,
            align: 'right',
            verticalAlign: 'top',
            x: -20,
            y: 20,
            itemStyle: {
                color: '#555',
                fontSize: '12px',
                fontWeight: '500',
            },
            itemHoverStyle: {
                color: '#2c3e50',
            },
        },
        plotOptions: {
            column: {
                pointPadding: 0.15,
                groupPadding: 0.1,
                borderWidth: 0,
                color: '#3498db',
                states: {
                    hover: {
                        color: '#2980b9',
                    },
                },
            },
            line: {
                marker: {
                    enabled: true,
                    radius: 5,
                    lineColor: '#ffffff',
                    lineWidth: 2,
                    fillColor: '#e74c3c',
                    states: {
                        hover: {
                            radius: 6,
                            fillColor: '#c0392b',
                        },
                    },
                },
                lineWidth: 3,
                states: {
                    hover: {
                        lineWidth: 4,
                    },
                },
            },
        },
        series: [
            {
                name: data?.seriesOptions[0].name,
                type: 'column',
                data: data?.chartData?.map((data) => Math.trunc(data.avg_amount, 0)),
                yAxis: 0,
                color: '#3498db',
            },
            {
                name: data?.seriesOptions[1].name,
                type: 'line',
                data: data?.chartData?.map((data) => data.cnt),
                yAxis: 1,
                color: '#e74c3c',
                marker: {
                    symbol: 'circle',
                },
            },
        ],
        credits: {
            enabled: false,
        },
    };

    return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default HousingChart;
